import './ExternalSideStream.scss';

import React from 'react';

const ExternalSideStream = props => {
    const {url, onFocusChange} = props;

    return <iframe className="ExternalSideStream" src={url} onMouseOver={() => onFocusChange(true)} onMouseLeave={() => onFocusChange(false)} />;
};

export default ExternalSideStream;
